import { useEffect } from "react"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { favoriteActions } from "redux/slice/favoriteSlice"
import { favoriteSelector } from "redux/selector"
import Loading from "components/Loading"
import { useLocation, useParams } from "react-router-dom"
import Pagination from '@mui/material/Pagination';
import TourItem from "components/TourItem"
import styled from "styled-components"

const FavoriteWrapper = styled.div`
    min-height: 70vh;
    .favorite_item{
        position: relative;
        height: 100%;
        .btn_remove{
            position: absolute;
            top: 10px;
            right: 10px;
            cursor: pointer;
            background: red;
            color: wheat;
            border-radius: 12px;
            padding: 2px 4px;
        }
    }
`

const PER_PAGE = 5

const Favorite = () => {
    const dispatch = useDispatch()
    const favoriteState = useSelector(favoriteSelector)
    const location = useLocation()
    const query = new URLSearchParams(location.search)
    const qPage = query.get("page")
    const [currentPage, setCurrentPage] = useState(qPage ? parseInt(qPage) : 1)
    const { setParams } = useParams()

    const handleChangePaginate = (event, pageNumber) => {
        setCurrentPage(pageNumber)
        setParams({ page: pageNumber })
    }

    useEffect(() => {
        dispatch(favoriteActions.getFavorite({ page: currentPage, perPage: PER_PAGE }))
    }, [currentPage, dispatch])

    const handleRemove = (id) => {
        if (!favoriteState.loading) {
            dispatch(favoriteActions.removeFavorite({ id, page: currentPage, perPage: PER_PAGE }))
        }
    }

    return (
        <FavoriteWrapper>
            <div className="container">
                <div className="pt-30">
                    <h1 className="text-black s-18 bg-grey2 p-15 b-radius-4">Danh sách yêu thích</h1>
                </div>
                <div className="tour_list mt-20">
                    {
                        favoriteState.favorites.length > 0 &&
                        <div className="row">
                            {
                                favoriteState.favorites.map((item, key) => (
                                    <div className="l-3" key={key}>
                                        <div className="favorite_item">
                                            <TourItem
                                                thumbnail={item.thumbnail}
                                                tourName={item.name}
                                                tourPrice={item.final_price}
                                                discount={item.discount}
                                                tourOldPrice={item.price}
                                                slug={item.slug}
                                            />
                                            <span className="text-link s-16 btn_remove clickable"
                                                onClick={() => handleRemove(item.id)}
                                            >Xóa</span>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    }
                    {
                        favoriteState.favorites.length === 0 &&
                        <div className="empty_data flex-center">
                            <span className="text-red">Danh sách yêu thích trống!</span>
                        </div>

                    }

                </div>
                {
                    favoriteState.totalPage > 1 &&
                    <div className="flex-center mt-50">
                        <Pagination color="primary" count={favoriteState.totalPage} variant="outlined" shape="rounded"
                            onChange={(event, pageNumber) => handleChangePaginate(event, pageNumber)}
                            page={currentPage}
                        />
                    </div>
                }
                {
                    favoriteState.loading &&
                    <Loading />
                }
            </div>
        </FavoriteWrapper>
    )
}

export default Favorite